"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactKonva = require("react-konva");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("../../config/colors");

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var Question = function Question(_ref) {
  var image = _ref.image,
      shapeProps = _ref.shapeProps,
      isSelected = _ref.isSelected,
      onSelect = _ref.onSelect,
      onChange = _ref.onChange,
      stageWidth = _ref.stageWidth,
      stageHeight = _ref.stageHeight,
      question = _ref.question,
      onChangePage = _ref.onChangePage,
      pagesLimit = _ref.pagesLimit;

  var shapeRef = _react["default"].useRef();

  var trRef = _react["default"].useRef();

  var _useState = (0, _react.useState)(true),
      questionCreated = _useState[0],
      setQuestionCreated = _useState[1];

  var currentQuestion = question || image;
  var _window$pdfFormConfig = window.pdfFormConfigObject.field_types,
      radioField = _window$pdfFormConfig.radio_field,
      checkBoxField = _window$pdfFormConfig.checkbox_field,
      _window$pdfFormConfig2 = _window$pdfFormConfig.multi_checkbox_field,
      multiCheckboxField = _window$pdfFormConfig2 === void 0 ? 27 : _window$pdfFormConfig2; // Check if multi_checkbox is enabled in config (default is true)

  var multiCheckboxEnabled = window.pdfFormConfigObject.enableMultiCheckbox !== false;
  (0, _react.useEffect)(function () {
    if (isSelected) {
      // attach transformer manually
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected, shapeProps]); // eslint-disable-next-line no-unused-vars

  var _useState2 = (0, _react.useState)({
    width: image.data.pos[2] * stageWidth / 100,
    height: image.data.pos[3] * stageHeight / 100
  }),
      imageSize = _useState2[0],
      _setImageSize = _useState2[1];

  var handleOnDragEnd = function handleOnDragEnd(e) {
    var newDataPos = shapeProps.data;
    newDataPos.pos[0] = 100 * (e.target.x() / stageWidth);
    newDataPos.pos[1] = 100 * (e.target.y() / stageHeight);

    if (question) {
      onChange((0, _extends2["default"])({}, shapeProps, {
        data: newDataPos
      }), question);
    } else {
      onChange((0, _extends2["default"])({}, shapeProps, {
        data: newDataPos
      }));
    }

    var container = e.target.getStage().container();
    container.style.cursor = 'default';
  };

  var handleOnMouseEnter = function handleOnMouseEnter(e) {
    var container = e.target.getStage().container();
    container.style.cursor = 'move';
  };

  var handleOnMouseLeave = function handleOnMouseLeave(e) {
    var container = e.target.getStage().container();
    container.style.cursor = 'default';
  };

  var handleOnTransformEnd = function handleOnTransformEnd() {
    var groupNode = shapeRef.current;
    var imageNode = groupNode.findOne('Image');

    if (!imageNode) {
      return;
    } // Retrieve the scales of the group


    var scaleX = groupNode.scaleX();
    var scaleY = groupNode.scaleY(); // Calculate effective dimensions of the image after scaling

    var effectiveWidth = imageNode.width() * scaleX;
    var effectiveHeight = imageNode.height() * scaleY;
    var newDataPos = shapeProps.data;
    newDataPos.pos[2] = effectiveWidth / stageWidth * 100;
    newDataPos.pos[3] = effectiveHeight / stageHeight * 100;

    if (question) {
      onChange((0, _extends2["default"])({}, shapeProps, {
        data: newDataPos
      }), question);
    } else {
      onChange((0, _extends2["default"])({}, shapeProps, {
        data: newDataPos
      }));
    }
  };

  var isNeitherRadioNorCheckbox = function isNeitherRadioNorCheckbox(type) {
    return (// If multi_checkbox is disabled, don't check against it
      type !== radioField && type !== checkBoxField && (multiCheckboxEnabled ? type !== multiCheckboxField : true)
    );
  };

  var isRadioOrCheckbox = currentQuestion.question_type === checkBoxField || currentQuestion.question_type === radioField || currentQuestion.question_type === multiCheckboxField;

  var setAnchors = function setAnchors(curQuestion) {
    if (curQuestion && isNeitherRadioNorCheckbox(curQuestion.question_type)) {
      return ['middle-right', 'bottom-right'];
    }

    return ['bottom-right'];
  };

  var setBound = function setBound(pos) {
    var newXBoundary;
    var newYBoundary;
    var page = question ? question.data.page : image.data.page; // eslint-disable-next-line

    if (pos.x + image.data.pos[2] * stageWidth / 100 >= stageWidth) {
      // eslint-disable-next-line
      newXBoundary = stageWidth - image.data.pos[2] * stageWidth / 100;
    } else if (pos.x <= 0) {
      newXBoundary = 0;
    } else {
      newXBoundary = pos.x;
    }

    if (pos.y <= 0) {
      switch (page) {
        case 1:
          newYBoundary = 0;
          break;

        default:
          if (questionCreated) {
            onChangePage(false, image.data.pos[3]);
            setQuestionCreated(false);
          }

          break;
      } // eslint-disable-next-line

    } else if (pos.y + image.data.pos[3] * stageHeight / 100 >= stageHeight) {
      if (page >= pagesLimit) {
        // eslint-disable-next-line
        newYBoundary = stageHeight - image.data.pos[3] * stageHeight / 100;
      } else if (questionCreated) {
        onChangePage(true, image.data.pos[3]);
        setQuestionCreated(false);
      } // newYBoundary = pos.y;

    } else {
      newYBoundary = pos.y;
    }

    return {
      x: newXBoundary,
      y: newYBoundary
    };
  };

  var fontSize = imageSize.height * 0.6; // 30% of the image's height

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactKonva.Group, {
      x: image.data.pos[0] * stageWidth / 100,
      y: image.data.pos[1] * stageHeight / 100,
      draggable: true,
      onDragEnd: handleOnDragEnd,
      onTransformEnd: handleOnTransformEnd,
      onMouseEnter: handleOnMouseEnter,
      onMouseLeave: handleOnMouseLeave,
      dragBoundFunc: setBound,
      onDragStart: onSelect,
      ref: shapeRef,
      onClick: onSelect,
      onTap: onSelect,
      "data-testid": "question"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactKonva.Image, {
      width: imageSize.width,
      height: imageSize.height,
      stroke: currentQuestion.filler === 'manager' ? _colors.MANAGER_QUESTION_FILL_COLOR : _colors.EMPLOYEE_QUESTION_FILL_COLOR,
      strokeWidth: 1,
      fill: currentQuestion.filler === 'manager' ? _colors.MANAGER_QUESTION_FILL_COLOR : _colors.EMPLOYEE_QUESTION_FILL_COLOR,
      opacity: 1.0
    }),
    /*#__PURE__*/
    _react["default"].createElement(_reactKonva.Text, {
      listening: false,
      width: isRadioOrCheckbox ? imageSize.width * 10 : imageSize.width,
      height: imageSize.height,
      text: isRadioOrCheckbox ? image.name : currentQuestion.name,
      fontSize: fontSize,
      fill: "#999",
      align: isNeitherRadioNorCheckbox(currentQuestion.question_type) ? 'center' : 'left',
      verticalAlign: "middle",
      offsetX: isNeitherRadioNorCheckbox(currentQuestion.question_type) ? image.data.pos[2] / stageWidth / 100 : -(image.data.pos[2] / stageWidth * 2) // Position text to the right of checkbox
      ,
      offsetY: image.data.pos[3] / stageHeight / 100
    })), isSelected &&
    /*#__PURE__*/
    _react["default"].createElement(_reactKonva.Transformer, {
      ref: trRef,
      rotateEnabled: false,
      enabledAnchors: setAnchors(currentQuestion),
      boundBoxFunc: function boundBoxFunc(oldBox, newBox) {
        if (newBox.width < 5 || newBox.height < 5) {
          return oldBox;
        }

        return newBox;
      }
    }))
  );
};

Question.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line
  image: _propTypes["default"].object.isRequired,
  // eslint-disable-next-line
  shapeProps: _propTypes["default"].object.isRequired,
  isSelected: _propTypes["default"].bool.isRequired,
  onSelect: _propTypes["default"].func.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  stageWidth: _propTypes["default"].number.isRequired,
  stageHeight: _propTypes["default"].number.isRequired,
  // eslint-disable-next-line
  question: _propTypes["default"].object,
  onChangePage: _propTypes["default"].func.isRequired,
  pagesLimit: _propTypes["default"].number.isRequired
} : {};

var _default = exports["default"] = Question;